import { render, staticRenderFns } from "./ApparelNameModal.vue?vue&type=template&id=1a7bbef7&scoped=true&"
import script from "./ApparelNameModal.vue?vue&type=script&lang=js&"
export * from "./ApparelNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7bbef7",
  null
  
)

export default component.exports